import { memo } from 'react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  pathClassName?: string;
  fill?: string;
};

// TODO, this is the same as icon-back.svg, should remove the svg
const ArrowIcon = (props: Props) => {
  const { fill, pathClassName = 'Fill($c-ds-icon-secondary)', ...restProps } = props;

  return (
    <SvgIcon {...restProps}>
      <path
        className={pathClassName}
        d="M13.98 20.717a1.79 1.79 0 0 0 2.685 0 1.79 1.79 0 0 0 0-2.684l-7.158-6.62 7.158-6.8a1.79 1.79 0 0 0 0-2.684 1.79 1.79 0 0 0-2.684 0L5.929 9.98a1.79 1.79 0 0 0 0 2.684l8.052 8.052z"
        fill={fill}
      />
    </SvgIcon>
  );
};

ArrowIcon.normalized = true;

export default memo(ArrowIcon);
